var React = require('react');

function SMS (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.5 3A1.5 1.5 0 003 4.5v30A1.5 1.5 0 004.5 36h6a1.5 1.5 0 011.5 1.5v6l9.6-7.2a1.5 1.5 0 01.9-.3h21a1.5 1.5 0 001.5-1.5v-30A1.5 1.5 0 0043.5 3h-39zM0 4.5C0 2.016 2.016 0 4.5 0h39C45.984 0 48 2.016 48 4.5v30c0 2.484-2.016 4.5-4.5 4.5H23l-11.6 8.7A1.5 1.5 0 019 46.5V39H4.5A4.501 4.501 0 010 34.5v-30z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 15a1.5 1.5 0 011.5-1.5h27a1.5 1.5 0 010 3h-27A1.5 1.5 0 019 15zm0 9a1.5 1.5 0 011.5-1.5h21a1.5 1.5 0 010 3h-21A1.5 1.5 0 019 24z","key":1})]);
}

SMS.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SMS;

SMS.default = SMS;
